<template>
  <div>
    <base-dialog v-model="dialogVisible" :content="$store.state.dialogMsg"></base-dialog>
		<base-modal v-model="todayHealthConditionGraphVisible" @hidden="todayHealthConditionGraphVisible = false">
			<clinic-history-variable-chart coloringPoints :variableName="HEALTH_CONDITION_TODAY" dynamicXAxis oneValuePerDay :label="$t('patient-panel.health-condition-graph-label')" :maxValue="10"></clinic-history-variable-chart>
		</base-modal>
		<health-sliders-modal v-if="showHealthSliderModal" :variables="[HEALTH_CONDITION_TODAY]" :showTitle="false" @save="onTodayHealthConditionSave" hideFooter></health-sliders-modal>
    <div class="row landing-cnt panel-cnt">
      <!-- <div class="bg-heart d-none d-xl-block"></div> -->
      <!-- Main block logged -->
      <div class="col-12 my-lg-auto my-0 logged-ctn">
        <div class="logged-title-ctn mb-4 mb-xl-6 mx-auto text-center">
          <h1 class="mb-4 panel">{{ $t('patient-panel.welcome', { platform: getPlatformName }) }}</h1>
          <!-- <h3 class="blue" v-if="!feelingTodayButtonVisible">
            {{ $t('patient-panel.what-do-you-need') }}
          </h3> -->
					<base-button variant="success" @click="onTodayHealthConditionButtonClick" class="one-liner-btn" v-if="$store.state.session.user && $store.getters['session/userHasCompanies']">
						{{ $t('patient-panel.how-do-you-feel-today', { name: $store.state.session.user.firstName }) }}
					</base-button>
        </div>
        <PatientPanelBlocks></PatientPanelBlocks>
        <!-- <a href="#" @click="$helpers.goToPatientWebApp('profile', $apiToken)" class="mt-5 d-block"><base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg" class="mr-2" :color="BLUE_COLOUR"/>{{ $t('patient-panel.show-more') }}</a> -->
      </div>
      <div class="learn-more" @click="goToSection('integral-solutions')" v-if="!$store.getters['session/isLogged']">
        <span>{{ $t('learn-more-btn') }}</span>
      </div>
    </div>
    <base-dialog :okBtnVisible="false" :cancelFn="() => { showSurveyDialog = false }" v-model="showSurveyDialog" :dontShowAgainCookie="surveyDialogKey" :hideFooter="hideSurveyDialogFooter">
        <div class="survey-content">
            <SurveyTest :surveyIdProp="surveyAvailable" @surveyCompleted="handleSurveyCompletion" @surveyStarted="handleSurveyStarted"/>
        </div>
    </base-dialog>
  </div>
</template>

<script>
import { BNavbar, BNavbarNav, BNavbarBrand, BNavbarToggle, BCollapse, BNavItem } from 'bootstrap-vue'
import LangSelector from '@/components/base/LangSelector'
import layoutMixin from '@/mixins/layout.mixin'
import PatientPanelBlocks from '@/components/PatientPanelBlocks'
import { inOpensalud360, getPlatformName } from '@/constants/platformNames'
import { BLUE_COLOUR } from '@/constants/colours'
import BaseDialog from '@/components/base/BaseDialog.vue'
import { UPDATE_TODAY_HEALTH_CONDITION } from '@/constants/loginOptionalActions'
import { HEALTH_CONDITION_TODAY } from '@/constants/clinicHistory'
import HealthSlidersModal from '@/components/webapp/shared/HealthSlidersModal.vue'
import BaseModal from '@/components/base/BaseModal.vue'
import ClinicHistoryVariableChart from '@/components/shared/ClinicHistoryVariableChart.vue'
import SurveyRepository from '@/repositories/SurveyRepository'
import SurveyTest from '../../views/surveys/SurveyTest.vue'

export default {
  mixins: [layoutMixin],
  name: 'landing-menu',
  components: {
    'sign-up': () => import('@/components/views/SignUp'),
    BNavbar,
    BNavbarNav,
    BNavbarBrand,
    BNavbarToggle,
    BNavItem,
    BCollapse,
    LangSelector,
    PatientPanelBlocks,
    BaseDialog,
		HealthSlidersModal,
		BaseModal,
		ClinicHistoryVariableChart,
    SurveyTest
  },
  data () {
    return {
      surveyAvailable: null,
      surveyCompleted: false,
			showSurveyDialog: false,
      hideSurveyDialogFooter: false,
      getPlatformName: getPlatformName(),
      BLUE_COLOUR,
			HEALTH_CONDITION_TODAY,
			showHealthSliderModal: false,
			todayHealthConditionGraphVisible: false
    }
  },
	methods: {
    handleSurveyCompletion () {
      this.surveyCompleted = true
      setTimeout(async () => {
          this.showSurveyDialog = false
					this.hideSurveyDialogFooter = false
					await this.checkSurveyAvailable()
      }, 5000)
    },
    async checkSurveyAvailable () {
            try {
                const response = await SurveyRepository.getSurveyAvailable()
                this.surveyAvailable = response.data

                if (this.surveyAvailable && !this.hideSurveyDialog) {
                    this.showSurveyDialog = true
                }
            } catch (error) {
                this.$store.dispatch('showDangerAlert', this.$i18n.t('surveys.error.error-loading'))
            }
    },
		onTodayHealthConditionButtonClick () {
			if (this.todayHealthConditionCompleted) {
				/* this.$router.push(`/patient/clinic-history/health-data?section=${ADDITIONAL_VARS_SECTION}&variable=${HEALTH_CONDITION_TODAY}&graph=true`) */
				this.todayHealthConditionGraphVisible = true
			} else {
				this.showHealthSliderModal = true
			}
		},
		onTodayHealthConditionSave (variableName, values) {
			const value = values[0]
			if (variableName === HEALTH_CONDITION_TODAY) {
				this.showHealthSliderModal = false
				if (value > 7) {
					this.$store.dispatch('showSuccessAlert', this.$t('patient-panel.today-health-condition-saved-nice'))
				} else if (value > 4) {
					this.$store.dispatch('showSuccessAlert', this.$t('patient-panel.today-health-condition-saved-ok'))
				} else {
					this.$store.dispatch('showSuccessAlert', this.$t('patient-panel.today-health-condition-saved-bad'))
				}
				this.$store.commit('session/removeLoginOptionalAction', UPDATE_TODAY_HEALTH_CONDITION)
			}
		},
		handleSurveyStarted () {
			this.hideSurveyDialogFooter = true
		}
	},
    watch: {
        dontShowAgain (value) {
            if (this.surveyAvailable) {
                localStorage.setItem(this.surveyDialogKey, value)
            }
        }
    },
  mounted () {
    if (inOpensalud360() && this.$store.getters['session/userHasCompanies'] === false) {
      this.$router.push('/inicio-sesion')
    }
    this.$store.commit('setLoading', false)
    this.checkSurveyAvailable()
  },
  computed: {
    surveyDialogKey () {
      return `hideSurveyDialog_${this.surveyAvailable}`
    },
    hideSurveyDialog () {
      return localStorage.getItem(this.surveyDialogKey) === 'true'
    },
    dialogVisible () {
      return !!this.$store.state.dialogMsg
    },
		todayHealthConditionCompleted () {
			return !(this.$store.state.session.loginOptionalActions && this.$store.state.session.loginOptionalActions.includes(UPDATE_TODAY_HEALTH_CONDITION))
		}
  }
}
</script>

<style lang="scss" scoped>
  @import "static-appopensalud/css/public/views/360.scss";

	.one-liner-btn {
		max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/Panel.vue